import { useAuth } from '@/hooks'
import { hasPermission } from '@/hooks/useBackendMenu'
import {
    compensacaoManual,
    CreateCompensacaoManual,
    createCompensacaoManualSchema,
} from '@/service/api'
import { useStore } from '@/store'
import dayjs from 'dayjs'
import Dialog from 'global/guides/Dialog'
import { useParams, useSearchParams } from 'react-router-dom'
import { toast } from 'sonner'
import FormCompensacaoManual from '../../CompensacaoManual/forms/FormCompensacaoManual'
import { invalidateDigitacaoQueries } from '../pages/useDigitacaoData'

export default function NovaCompensacaoManual() {
    const { mutateAsync, isLoading } = compensacaoManual.mutations.useCreate()
    const funcionarioId = useStore(state => state.employeeId)
    const empresaId = useStore(state => state.companyId)
    const competencia = useStore(state => state.selectedCompetence)
    const { decoded } = useAuth()
    const userId = decoded?.sub

    const params = useParams<{ dia: string }>()
    const [searchParams] = useSearchParams()
    const dia = dayjs.utc(params.dia!)

    // Lê os search params para determinar qual campo preencher
    const tipos = searchParams.getAll('tipo') // Pode ter 'falta' e/ou 'extra'
    const temFalta = tipos.includes('falta')
    const temExtra = tipos.includes('extra')

    // Define valores padrão baseado nos search params
    const getDefaultValues = () => {
        const defaults: any = {
            data: dia.format('YYYY-MM-DD'),
            destinos: [],
            empresaId,
            funcionarioId,
            competencia,
        }

        // Se tem falta, tipo COMPENSAR (dia com falta precisa ser compensado)
        if (temFalta && !temExtra) {
            defaults.tipo = 'COMPENSADO'
        }
        // Se tem extra, tipo COMPENSADO (dia com extra compensa outro)
        else if (temExtra && !temFalta) {
            defaults.tipo = 'COMPENSAR'
        }
        // Se tem ambos (falta e extra), padrão COMPENSAR
        else if (temFalta && temExtra) {
            defaults.tipo = 'COMPENSAR'
        }
        // Se não tem nada, não define o tipo (usuário escolhe)

        return defaults
    }

    function handleSubmit(data: CreateCompensacaoManual) {
        if (!userId || !funcionarioId) {
            toast.error('Selecione um funcionário')
            return
        }

        if (!empresaId) {
            toast.error('Selecione uma empresa')
            return
        }

        mutateAsync(
            {
                ...data,
                empresaId,
                funcionarioId,
            },
            {
                onSuccess: () => {
                    toast.success('Compensação manual criada com sucesso!')
                    invalidateDigitacaoQueries()
                },
                onError: err => {
                    toast.error(
                        err.message || 'Erro ao criar compensação manual',
                    )
                },
            },
        )
    }

    return (
        <Dialog.Root
            height="auto"
            width="45rem"
            onSubmit={handleSubmit}
            loading={isLoading}
            schema={createCompensacaoManualSchema}
            open={hasPermission(['create', 'CompensaçãoManual'])}
            defaultValues={getDefaultValues()}
        >
            <Dialog.Title>Nova Compensação Manual</Dialog.Title>
            <Dialog.Content dividers>
                <FormCompensacaoManual />
            </Dialog.Content>
            <Dialog.Actions>
                <Dialog.Actions.SecondaryButton />
                <Dialog.Actions.PrimaryButton closeOnSubmit />
            </Dialog.Actions>
        </Dialog.Root>
    )
}
